/**
 * Status pill colours for the personal area.
 *
 * Keyed by the customer-facing `statusTone` the personal-area API returns
 * (six progress stages + off-track tones). Raw admin statuses are no longer
 * shown to customers; `getStatusStyle` falls back to neutral grey for anything
 * unknown (e.g. an older API response that only carries the raw status).
 */

const SHADOW = '0 1px 2px rgba(0, 0, 0, 0.1)';

const STATUS_CONFIG = {
  // ── progress stages ──
  received:  { backgroundColor: '#FBBF24', color: '#1a1a1a' },                    // נקלטה
  queued:    { backgroundColor: '#F59E0B', color: '#fff', textShadow: SHADOW },   // נכנסה לתור
  printed:   { backgroundColor: '#2196F3', color: '#fff', textShadow: SHADOW },   // הודפסה
  framing:   { backgroundColor: '#0B9371', color: '#fff', textShadow: SHADOW },   // בשלבי מסגור ואריזה
  courier:   { backgroundColor: '#3F51B5', color: '#fff', textShadow: SHADOW },   // עברה לשליח
  delivered: { backgroundColor: '#2E7D32', color: '#fff', textShadow: SHADOW },   // נמסרה
  // ── off-track ──
  cancelled: { backgroundColor: '#F44336', color: '#fff', textShadow: SHADOW },
  returned:  { backgroundColor: '#E91E63', color: '#fff', textShadow: SHADOW },
  hold:      { backgroundColor: '#FFB74D', color: '#1a1a1a' },
  giftcard:  { backgroundColor: '#D9577F', color: '#fff', textShadow: SHADOW },
};

export const getStatusStyle = (tone) => {
  const config = STATUS_CONFIG[tone];
  if (!config) {
    return {
      backgroundColor: '#9e9e9e',
      color: '#fff',
    };
  }
  return {
    backgroundColor: config.backgroundColor,
    color: config.color,
    textShadow: config.textShadow,
  };
};

export default STATUS_CONFIG;
